module.exports = __webpack_public_path__ + "img/38_26.c0537f0a.png";